/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_BudgetInputs */

const en_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BUDGET`)
};

const ar_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ميزانية`)
};

const bn_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BUDGET`)
};

const de_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BUDGET`)
};

const es_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BUDGET`)
};

const fr_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BUDGET`)
};

const pt_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BUDGET`)
};

const zh_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BUDGET`)
};

const tr_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BUDGET`)
};

const ru_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BUDGET`)
};

const pl_svtag_budget = /** @type {(inputs: Svtag_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BUDGET`)
};

/**
* | output |
* | --- |
* | "#BUDGET" |
*
* @param {Svtag_BudgetInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_budget = /** @type {((inputs?: Svtag_BudgetInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_BudgetInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_budget(inputs)
	if (locale === "bn") return bn_svtag_budget(inputs)
	if (locale === "de") return de_svtag_budget(inputs)
	if (locale === "es") return es_svtag_budget(inputs)
	if (locale === "fr") return fr_svtag_budget(inputs)
	if (locale === "pt") return pt_svtag_budget(inputs)
	if (locale === "zh") return zh_svtag_budget(inputs)
	if (locale === "tr") return tr_svtag_budget(inputs)
	if (locale === "ru") return ru_svtag_budget(inputs)
	if (locale === "pl") return pl_svtag_budget(inputs)
	return en_svtag_budget(inputs)
});